import { render, staticRenderFns } from "./star-score.vue?vue&type=template&id=82e2076e&scoped=true&"
import script from "./star-score.vue?vue&type=script&lang=js&"
export * from "./star-score.vue?vue&type=script&lang=js&"
import style0 from "./star-score.vue?vue&type=style&index=0&id=82e2076e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e2076e",
  null
  
)

export default component.exports